<div class="row">
  <nav aria-label="Miga de pan predeterminada de dos niveles" style="padding: 1% 0 1% 74px">
    <ul class="breadcrumb-govco">
      <li *ngFor="let item  of ruta" class="breadcrumb-item-govco active" aria-current="page">
        <a href={{item.url}}> {{item.name}}</a>
      </li>
    </ul>
  </nav>
</div>